<template>
  <MetricTimeSeries
    :title="title"
    :item-id="itemId"
    :metric="metric"
    :operation="operation"
    :entity="entity"
    :label="label"
    :value-type="valueType"
    :owner-posts="true"
    v-bind="$attrs"
  />
</template>

<script>
import MetricTimeSeries from '@/components/cards/MetricTimeSeries';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropMetricTimeSeries',
  components: {
    MetricTimeSeries,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    metric: {
      type: [String, Array],
      default: null,
    },
    operation: {
      type: String,
      default: null,
    },
    entity: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    valueType: {
      type: String,
      default: null,
    },
  },
};
</script>
